import { useTranslation } from 'react-i18next'

import { FieldRow, FieldSkeleton, FieldsTable, FieldViewValue } from '@/components/layout/field-row'
import { TabCard } from '@/components/layout/tab-card'

const ROW_LABEL_KEYS = [
  'organisation:places.languages.i18nAvailable.label',
  'organisation:places.languages.available.label',
  'organisation:places.languages.default.label',
] as const

// Note: title and labels are real, only the values are skeletons
export const LanguagesTabSkeleton = () => {
  const { t } = useTranslation(['organisation'])

  return (
    <TabCard title={t('organisation:places.languages.title')}>
      <FieldsTable aria-hidden>
        {ROW_LABEL_KEYS.map((labelKey) => (
          <FieldRow key={labelKey} label={t(labelKey)}>
            <FieldViewValue>
              <FieldSkeleton height="1.6rem" width="20rem" />
            </FieldViewValue>
          </FieldRow>
        ))}
      </FieldsTable>
    </TabCard>
  )
}
